import { render, staticRenderFns } from "./ChannelFactor.vue?vue&type=template&id=1fa60ac4&"
import script from "./ChannelFactor.vue?vue&type=script&lang=js&"
export * from "./ChannelFactor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports